import {
  ADD_IN_BLOCKED_STAKES_QUEUE, AddInBlockedStakesQueue,
  DELETE_FROM_BLOCKED_STAKES_QUEUE, DeleteFromBlockedStakesQueue,
} from '../actions/waitingInQueue';
import type { WaitingInQueueState } from '../types/waitingInQueue';


export type WaitingInQueueActions =
  | AddInBlockedStakesQueue
  | DeleteFromBlockedStakesQueue;

const initialState:WaitingInQueueState = new Set();

export default function (
  state = initialState,
  action: WaitingInQueueActions,
): WaitingInQueueState {
  switch (action.type) {
    case ADD_IN_BLOCKED_STAKES_QUEUE:
      return new Set([...state, action.payload.dialogId]);

    case DELETE_FROM_BLOCKED_STAKES_QUEUE:
      const newQueue = new Set(state);
      newQueue.delete(action.payload.dialogId);
      return newQueue;

    default:
      return state;
  }
}
